<script>
  export { className as class }

  let className = ""

  export let shadowClass = "shadow-xl"
</script>

<div class="inline-block align-bottom text-left transform transition-all sm:align-middle {className} {shadowClass}">
  <slot />
</div>
